import { CourseCard } from '@/components/partial/course-card';
import { Carousel } from '@/components/shared/carousel';
import { useCatalogSearch } from '@/data/catalog/search';
import { CardsSkeleton } from '@/packages/home/components/skeleton';

interface CobrandedSectionProps {
  institutionId: number;
}

export const CobrandedSection = ({ institutionId }: CobrandedSectionProps) => {
  const queryParams = {
    filters: { institutions: [institutionId] },
    page: 1,
    page_size: 50,
  };

  const { data, isFetching } = useCatalogSearch(queryParams);
  const courses = data?.items;

  if (isFetching) return <CardsSkeleton withTextSkeleton={false} />;

  if (!courses?.length && !isFetching) return null;

  const slidesComponents = courses?.map((slide) => {
    return <CourseCard data={slide} key={slide.id} />;
  });

  return <Carousel slidesComponents={slidesComponents || []} />;
};
